import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UISkin } from '../models/ui.model';


@Injectable({
  providedIn: 'root',
})
export class AppService {
  
  insuredToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IlNzWnNCTmhaY0YzUTlTNHRycFFCVEJ5TlJSSSIsImtpZCI6IlNzWnNCTmhaY0YzUTlTNHRycFFCVEJ5TlJSSSJ9.eyJhdWQiOiJlNDEwNTU1ZS04ODA1LTRjYzItYTM3MS00MWQ0YjZjN2VjNzIiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC83ZjdhYzA3OS1jOWU5LTQ3MGMtYjFjMi03MDBmZTQxOTM0Y2EvIiwiaWF0IjoxNTk0MTY0NzcwLCJuYmYiOjE1OTQxNjQ3NzAsImV4cCI6MTU5NDE2ODY3MCwiYWlvIjoiRTJCZ1lPQVM4ZlVPVWx5MTUvUGFoT2VyOXUxaUJRQT0iLCJhcHBpZCI6ImU0MTA1NTVlLTg4MDUtNGNjMi1hMzcxLTQxZDRiNmM3ZWM3MiIsImFwcGlkYWNyIjoiMSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0LzdmN2FjMDc5LWM5ZTktNDcwYy1iMWMyLTcwMGZlNDE5MzRjYS8iLCJvaWQiOiJjYjI4MWQ5Ni0xM2ExLTQ4ZjQtOTZjMi1jOWFkM2JhMjBhMTQiLCJzdWIiOiJjYjI4MWQ5Ni0xM2ExLTQ4ZjQtOTZjMi1jOWFkM2JhMjBhMTQiLCJ0aWQiOiI3ZjdhYzA3OS1jOWU5LTQ3MGMtYjFjMi03MDBmZTQxOTM0Y2EiLCJ1dGkiOiIta20xbk5mT3IweXg3Ulp6WVIzSkFBIiwidmVyIjoiMS4wIn0.Vka9ttqrnEIE4naItlnPFFrdhviqfVvIbzEmA65XjUYTk_013xhT_evfK-wVSj8aubyUxporjo8lkNH6CgvPt3nXi57EoTRGRjHKTHTZlFpXi0vMJCgPbTQiCLJoZDblvvaNNlo-ePRoBJJlinVa4oakq0XglfanuYbt0WT5dbjdGuHMEcfpyUAcAgKLxsNR2IT3lCX9fnULcSdVR8FCSPgS2X59yODTOwwGJZtcMNlD-EqZ52pmY7GP8b2J2P-iMiYWipHt8wglk4AFgclkKI-ZJrDVaQ4kFzLdSvu_iaS0UgH7PuoMbKcPccS9qOtf7Rkkl89LBE1WGmBJj1oRUA';
  origin = '';
  api = 'insured/';
 // apiBase = 'https://directinspect-v2.azurewebsites.net/';

  constructor(private http: HttpClient) { }

  questions(pkge: object){
    return this.http.post(this.apiBase()+'questions?insuredKey='+this.insuredToken,pkge);
  }

  questionTemplate(templateId: string, pkge: object){
    return this.http.post(this.apiBase()+'template/'+templateId,pkge);
  }

  getUiSkin(){
    return this.http.get<UISkin>(this.apiBase()+'uiskin?insuredKey='+this.insuredToken);
  }

  getUiSkinTemplate(templateId: string){
    return this.http.get<UISkin>(this.apiBase()+'uiskintemplate?templateId='+templateId);
  }

  getSpecialPage(page:string){
    return this.http.get<any>(this.apiBase()+'specialpage/'+page+'?insuredKey='+this.insuredToken);
  }

  uploadPhotos(photo: any){
    let uPhoto = new FormData();
    uPhoto.append('InspectionId', photo.InspectionId);
    uPhoto.append('Image', photo.Image);
    uPhoto.append('Extension', photo.Extension);
    uPhoto.append('Latitude', photo.Latitude);
    uPhoto.append('Longitude', photo.Longitude);
    uPhoto.append('QuestionName', photo.QuestionName);

    return this.http.post<Object>(this.apiBase()+'photos?insuredKey='+this.insuredToken,uPhoto);
  }

  createSurvey(code: string, token: string) {
    return this.http.post<any>(this.apiBase()+'survey/'+code+'?insuredKey='+token,{});
  }

  apiBase(){
    // console.log(window.location.hostname);
   let base = 'https://captureqservicesuat-h3c0b4a3gzf2cyfv.southcentralus-01.azurewebsites.net/';
   if(window.location.hostname == 'uat.captureq.com'){
      //base = 'https://captureqservicesuat-h3c0b4a3gzf2cyfv.southcentralus-01.azurewebsites.net/';
    } else if(window.location.hostname == 'www.captureq.com' || window.location.hostname == 'captureq.com') {
      base = 'https://api.captureq.com/';
   } else if (window.location.hostname == 'localhost') {
     base = 'https://localhost:5001/';
   }
    return base+this.api;
  }
}
